import { REQUEST_URL } from "../constants";
import { RequestFileUtil, RequestUtil } from "../utils";

export const ImageService = {
  uploadImage,
  uploadProductImage,
  uploadCategoryImage,
  uploadBlogImage,
  uploadProductDescriptionImage,
};

async function uploadImage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD;

  return RequestUtil.post({ url, data: formData });
}

async function uploadProductImage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_PRODUCT;

  return RequestUtil.post({ url, data: formData });
}

async function uploadProductDescriptionImage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_PRODUCT_DESCRIPTION;

  return RequestUtil.post({ url, data: formData });
}

async function uploadCategoryImage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_CATEGORY;

  return RequestUtil.post({ url, data: formData });
}

async function uploadBlogImage(formData: FormData) {
  const url = REQUEST_URL.IMAGE.UPLOAD_BLOG;

  return RequestFileUtil.post({ url, data: formData });
}
